import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const IDFC = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards?.filter((card)=>card.category==="IDFC card").slice(indexOfFirstCard, indexOfLastCard);
  // console.log({currentCards})
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("idfc"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Are IDFC FIRST Bank credit cards really lifetime free?",
      answer:
        "  Yes, all IDFC FIRST Bank credit cards are lifetime free, with no joining fees or annual charges—a key USP that sets them apart in the market.",
    },
    {
      question: "What are the interest rates on IDFC credit cards?",
      answer:
        "  IDFC cards offer one of the lowest APRs in India, starting from 0.75% to 3.5% per month, depending on your repayment history and profile.",
    },
    {
      question: "Can I get cashback or rewards with IDFC cards?",
      answer:
        "  Yes, IDFC credit cards provide up to 10X reward points on online and offline spends, along with exclusive offers on travel, dining, and shopping.",
    },
    {
      question: "How soon can I expect to receive my card after approval?",
      answer:
        "  Once approved, the virtual credit card is issued instantly. The physical card is typically delivered within 7–10 working days.",
    },
    {
      question: " Can I track the status of my credit card application?",
      answer:
        "  Yes, IDFC Bank allows you to track your application status using your registered mobile number and reference ID via their official website or customer support.",
    },
  ];

  const steps = [
    {
      icon: <FaUserCheck className="h-6 w-6 text-orange-500" />,
      title: "Ensure You Meet the Eligibility",
      description:
        " Review the income, age, and credit score criteria before applying. Each card may have slightly different requirements, especially for higher-tier variants.",
    },
    {
      icon: <FaIdCard className="h-6 w-6 text-green-500" />,
      title: "Prepare Required Documentation",
      description:
        "Keep digital or physical copies of your identity, address, and income documents ready. This simplifies the application process once you’re redirected to the bank’s portal.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply Through IDFC Bank’s Official Website",
      description:
        " After choosing a suitable card on TheFinMaster, click “Apply Now” to get redirected to IDFC FIRST Bank’s secure website, where you can complete the application online.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        " Browse our curated collection of IDFC FIRST Bank credit cards on TheFinMaster. Our listings break down every important detail—such as reward structures, late fee policies, interest charges, eligibility, and user-specific advantages—helping you choose the right card confidently.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get IDFC FIRST Credit Card - Key Features and Benefits | Apply Online
          2024 | TheFinmaster
        </title>
        <meta
          name="description"
          content="Explore IDFC FIRST Banks wide range of credit cards like Millennia, Classic, Select, Wealth, Power Plus and WOW. Rewards, lounge access, fees and more. Learn how to apply online. | Thefinmaster"
        />
        <meta
          name="keywords"
          content="idfc first select credit card, idfc first millennia credit card benefits, idfc first wealth credit card, idfc first wow credit card, idfc vistara card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/idfc-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Discover Smart, Rewarding, and Zero-Fee Credit Cards by IDFC FIRST
              Bank
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              IDFC FIRST Bank offers a refreshing take on credit cards with
              features like lifetime free membership, low interest rates, and
              high rewards on every spend. With a strong focus on transparency
              and customer-first benefits, IDFC cards are well-suited for those
              seeking value-driven experiences without the burden of hidden
              charges or annual fees.
            </p>
          </div>
        </div>
        <h1 className="text-center text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                    key={index}
                    cardDetails={item}
                    Card_features={item?.Card_features}
                    fees={item?.fees}
                    cardName={item?.title}
                    cardImage={item?.image}
                    rating={item?.rating}
                    category={item?.category}
                    status={item?.status}
                    bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
                              <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                {/* <div className="w-[70%] mx-auto">
                                                           <h2 className="text-center font-medium pt-5 text-lg">
                                                             <span className="font-semibold text-white">816 people</span>{" "}
                                                             are on call with our advisors right now
                                                           </h2>
                                                         </div> */}
                                <div className="w-full mx-auto">
                                  <Link
                                    to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <div className="w-[80%] mx-auto ">
                                      <img src="/assets/new.png" alt="Advertisement" />
                                    </div>
                                  </Link>
                                  <div className="bg-white">
                                    {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                               Know your advisor
                                                             </h3> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for IDFC Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    {" "}
                    The applicant should be at least 21 years old and not older
                    than 60 years. This applies to both salaried and
                    self-employed individuals to ensure financial maturity and
                    creditworthiness.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    {" "}
                    A steady monthly income of ₹20,000 or above is generally
                    required. This helps determine the applicant's ability to
                    manage credit card payments and ensures financial
                    responsibility.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Criteria
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 700 or more is preferred. A strong credit
                    history increases approval chances and could also influence
                    the credit limit offered by the bank.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Occupation and Employment Status
                  </span>
                  <span>
                    {" "}
                    Both salaried and self-employed professionals are eligible.
                    Stability in employment or business continuity plays a role
                    in the bank’s assessment.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Location & KYC Compliance
                  </span>
                  <span>
                    {" "}
                    The applicant must be a resident of India with proper KYC
                    documents and a registered address that falls within the
                    serviceable areas of IDFC FIRST Bank’s credit card
                    operations.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for IDFC Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Government-issued IDs like Aadhaar, Passport, PAN, or
                    Driving License serve as valid proof of identity and are
                    required for KYC compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Residential Address
                  </span>
                  <span>
                    {" "}
                    Documents such as Aadhaar Card, electricity/water bills (not
                    older than 3 months), or rental agreement can be used to
                    verify your permanent or current address.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Latest 3 months' salary slips and bank statements
                    showing salary credits. Self-employed: Latest ITR with
                    income computation and supporting financial documents. These
                    help in assessing your repayment capacity and setting a
                    suitable credit limit.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Passport-size Photograph
                  </span>
                  <span>
                    {" "}
                    A recent color photo is necessary for the application form
                    and is used in your card profile and verification steps.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    Mandatory for application processing. It helps the bank
                    validate your financial background and link your credit
                    history.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for IDFC FIRST Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default IDFC;
